module.exports = __webpack_public_path__ + "img/2698315.dec2806c.svg";